import React from 'react';
import clsx from 'clsx';
import styles from './text.module.css';

export type TextProps = {
  code?: boolean;
  as?: any;
  gradient?: boolean;
  truncate?: boolean;
  color?: 'primary' | 'secondary' | 'tertiary' | 'inherit';
  display?: 'inline' | 'block';
  variant?:
    | 'subtitle1'
    | 'title1'
    | 'title2'
    | 'title3'
    | 'header1'
    | 'header2'
    | 'displayXL'
    | 'display1'
    | 'display2'
    | 'display3'
    | 'body1'
    | 'body2'
    | 'badge'
    | 'link'
    | 'navigation'
    | 'time'
    | 'chip';
} & React.HTMLAttributes<HTMLElement>;

function TextComponent(
  {
    gradient = false,
    color = 'primary',
    as: Component = 'span',
    display = 'inline',
    className,
    variant = 'body2',
    truncate = false,
    code,
    ...other
  }: TextProps,
  ref: any
) {
  return (
    <Component
      ref={ref}
      className={clsx(
        styles.shared,
        styles[variant],
        styles[color],
        {
          [styles.gradient]: gradient,
          [styles.block]: display === 'block',
          [styles.code]: code,
          [styles.truncate]: truncate,
        },
        className
      )}
      {...other}
    />
  );
}

export const Text = React.forwardRef(TextComponent);
